<template>
  <div class="tsMg" style="text-align: left; ">
    <el-dropdown>
      <el-button type="primary" style="padding-right: 10px">
        推荐类别({{tjName}})<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown" >
        <el-dropdown-item v-for="item in tjList" @click.native="setTj(item.name)" :key="item.id">{{item.name}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="edit_dev" style="margin: 0 auto; display: flex; justify-content: space-between ">
      <el-transfer
        v-model="value"
        filterable
        :data="data"
        :filter-method="filterMethod"
        :target-order="'push'"
        :titles="['电子书列表', '推荐列表']"
        :props="{ key: 'id', label: 'label' }"
        :left-default-checked="hasCheckedWHLeftData"
        @left-check-change="handleWHLeftChange"
        :right-default-checked="hasCheckedWHRightData"
        @right-check-change="handleWHRightChange"
      ></el-transfer>
      <div style="width: 200px; background-color: #ebb563; padding: 30px;">
        <div style="text-align: center; line-height: 50px">TIP</div>
        <span>
            1、勾选电子书列表内电子书，点击右侧按钮，可设置当前信息为推荐列表内容;
            2、拖拽推荐列表内容，可调整推荐列表内顺序;
          </span>
      </div>
    </div>

  </div>
</template>
<script>
  import Sortable from "sortablejs";
  import { qryAllEbookList,qrySubEbookInfoList,updateSubEbookList } from '../../request/api';

  export default {
    name: "DragSortMultiSelect",
    data() {
      return {
        tjName: '首页推荐',
        tjList: [
          {
            id: 1,
            name: '首页推荐'
          },
          {
            id: 2,
            name: '佳作分享'
          },
          {
            id: 3,
            name: '综合推荐'
          },
        ],
        filterMethod(query, item) {
          let regStr = query.replace(/\*/g, ".*");
          let reg = new RegExp(regStr);
          return reg.test(item.label);
        },
        data: [],
        value: [],
        shiftKey: false,
        firstWHLeftLocation: -1, //数据左边起始值
        lastWHLeftLocation: -1, //数据左边终止值
        hasCheckedWHLeftData: [], //数据左边选中的数据
        firstWHRightLocation: -1, //数据右边起始值
        lastWHRightLocation: -1, //数据右边终止值
        hasCheckedWHRightData: [] //数据右边选中的数据
      };
    },
    watch: {
      value(newVal,oldValue) {
        this.updateSubBookInfo()
      }
    },
    mounted() {
      this.loadBookList()
      this.loadSubBookList()
      window.addEventListener("keydown", e => {
        if (e.keyCode === 16 && e.shiftKey) {
          this.shiftKey = true;
        }
      });
      window.addEventListener("keyup", e => {
        this.shiftKey = false;
      });
      let el = document
        .querySelector(".tsMg .el-transfer")
        .querySelectorAll(".tsMg .el-checkbox-group")[1];
      new Sortable(el, {
        forceFallback: false,
        onUpdate: event => {
          let box = this.$el
            .querySelector(".tsMg .el-transfer")
            .querySelectorAll(".tsMg .el-checkbox-group")[1];
          let nums = this.$el
            .querySelector(".tsMg .el-transfer")
            .querySelectorAll(".tsMg .el-checkbox-group")[1].childNodes.length;
          console.log(nums, event.newIndex);
          if (event.newIndex >= nums) {
            return;
          }
          let newIndex = event.newIndex;
          let oldIndex = event.oldIndex;
          let $label = box.children[newIndex];
          let $oldLabel = box.children[oldIndex];
          box.removeChild($label);
          if (newIndex < oldIndex) {
            box.insertBefore($label, $oldLabel);
          } else {
            box.insertBefore($label, $oldLabel.nextSibling);
          }
          let item = this.value.splice(oldIndex, 1);
          this.value.splice(newIndex, 0, item[0]);
        }
      });
    },
    methods: {
      setTj(name) {
        this.tjName = name
        this.loadSubBookList()
        this.loadBookList()
      },
      updateSubBookInfo() {
        let param = {
          idList: this.value,
          tjName: this.tjName
        }
        updateSubEbookList(param).then(
          resp => {
            if (resp.code === 1) {
              let bookList = []
              resp.data.forEach((book, index) => {
                bookList.push({
                  label: book.title,
                  id: book.id
                });
              });
              this.data = bookList;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadBookList() {
        let param = {}
        qryAllEbookList(param).then(
          resp => {
            if (resp.code === 1) {
              let bookList = []
              resp.data.forEach((book, index) => {
                bookList.push({
                  label: book.title,
                  id: book.id
                });
              });
              this.data = bookList;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      loadSubBookList() {
        let param = {
          tjName: this.tjName
        }
        qrySubEbookInfoList(param).then(
          resp => {
            if (resp.code === 1) {
              this.value = resp.data;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },

      // 数据左侧列表元素被用户选中 / 取消选中时触发
      handleWHLeftChange(key, key1) {
        var _this = this;
        console.log(_this.hasCheckedWHLeftData);
        _this.hasCheckedWHLeftData = _this.commonChangeFuc(
          key,
          key1,
          _this.hasCheckedWHLeftData,
          _this.firstWHLeftLocation,
          _this.lastWHLeftLocation,
          _this.data,
          "id"
        );
        console.log(_this.hasCheckedWHLeftData);
      },
      // 数据右侧列表元素被用户选中 / 取消选中时触发
      handleWHRightChange(key, key1) {
        var _this = this;
        console.log(_this.hasCheckedWHRightData);
        _this.hasCheckedWHRightData = _this.commonChangeFuc(
          key,
          key1,
          _this.hasCheckedWHRightData,
          _this.firstWHRightLocation,
          _this.lastWHRightLocation,
          _this.value,
          false
        );
        console.log(_this.hasCheckedWHRightData);
      },
      // 公共按住shift 多选
      commonChangeFuc(
        key,
        key1,
        hasCheckedData,
        firstLocation,
        lastLocation,
        arrList,
        value
      ) {
        var _this = this;
        var cFlag = false; //取消勾选
        // debugger
        for (var i = 0; i < key.length; i++) {
          if (key[i] == key1[0]) {
            cFlag = true; //选中
          }
        }
        if (cFlag) {
          if (key.length == 1) {
            firstLocation = 0;
            hasCheckedData.push(key[0]);
          } else if (key.length > 1) {
            let arr = [];
            // 当前有选中数据 并且 按住shift
            if (_this.shiftKey) {
              // if (isRight) {
              for (let i = 0; i < arrList.length; i++) {
                let item = value ? arrList[i][value] : arrList[i];
                if (item == key[key.length - 2]) {
                  firstLocation = i;
                }
                if (item == key1[0]) {
                  lastLocation = i;
                }
              }
              if (firstLocation != -1 && lastLocation != -1) {
                if (firstLocation < lastLocation) {
                  for (var k = 0; k < arrList.length; k++) {
                    let item = value ? arrList[k][value] : arrList[k];

                    if (k >= firstLocation && k <= lastLocation) {
                      hasCheckedData.push(item);
                    }
                  }
                } else if (firstLocation > lastLocation) {
                  for (var k = 0; k < arrList.length; k++) {
                    if (k >= lastLocation && k <= firstLocation) {
                      hasCheckedData.push(item);
                    }
                  }
                }
              }
            } else {
              //不再按shift
              hasCheckedData.push(key1[0]);
            }
          }
        } else {
          //取消选中的
          hasCheckedData = [];
          for (var i = 0; i < key.length; i++) {
            if (key[i] != key1[0]) {
              hasCheckedData.push(key[i]);
            }
          }
        }
        // 去重
        hasCheckedData = new Set(hasCheckedData);
        hasCheckedData = Array.from(hasCheckedData);
        return hasCheckedData;
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .edit_dev >>> .el-transfer-panel{
    width: calc((100vw - 720px) / 2);
    height: calc(100vh - 200px);
  }
  .edit_dev >>> .el-transfer-panel__list.is-filterable{
    height: calc(100vh - 335px);
  }


</style>



// WEBPACK FOOTER //
// src/components/syzy/tstjgl.vue